"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_schema_types_1 = require("@aurora/shared-generated/types/graphql-schema-types");
const types_1 = require("./types");
class ExtraLightStyle {
    constructor() {
        this.name = types_1.FontStyleName.EXTRALIGHT;
        this.style = graphql_schema_types_1.FontStyle.Normal;
        this.weight = 200;
    }
}
exports.default = ExtraLightStyle;
//# sourceMappingURL=ExtraLightStyle.js.map